import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";

import Login from "./pages/Login";
import Admin from "./pages/Admin";
import { auth } from "./firebase/firebase";
import Hero from "./components/Hero";

import Banner from "./components/Banner";
import GlobalBackground from "./components/GlobalBackground";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons"; // Yeni eklendi
import Hizmetlerimiz from "./components/Hizmetlerimiz"; // Yeni eklendi
import SSS from "./components/SSS"; // Yeni eklendi
import Iletisim from "./components/Iletisim"; // Yeni eklendi
import Gizlilik from "./components/Gizlilik"; // Yeni eklendi
import Kullanim from "./components/Kullanim"; // Yeni eklendi
import Aydinlatma from "./components/Aydinlatma"; // Yeni eklendi
import RandevuAl from "./components/RandevuAl";
import KVKK from "./components/kvkk";
import CalismaAlanlari from "./components/CalismaAlanlari";
import Videolar from "./pages/Videolar";
import Hakkimda from "./pages/Hakkimda.jsx";
import Egitimler from "./pages/Egitimler.jsx";
import EgitimDetail from "./pages/EgitimDetail.jsx";
import IlcePsikolog from "./pages/IlcePsikolog.jsx";
import NotFound from "./components/NotFound";
import SEO from "./components/SEO";

function App() {
  return (
    <BrowserRouter>
      <GlobalBackground>
        <Banner />
        <Hero />

        <Routes>
          <Route path="/" element={<><SEO title="Antalya Psikolog Aysun Şeremet | EMDR Uzm. Klinik Psk." description="Antalya Uzman Klinik Psikolog Aysun Şeremet — EMDR (Avrupa Akredite Uygulayıcı), Şema Terapi, BDT. Yetişkin, çocuk, ergen ve aile terapisi. Online & yüz yüze." canonical="https://aysunseremet.com/" /><Home /></>} />
          <Route path="/blog" element={<><SEO title="Blog — Psikoloji & EMDR Yazıları | Antalya Psikolog Aysun Şeremet" description="EMDR, çocuk-ergen, ilişkiler ve ruh sağlığı üzerine yazılar. Uzman Klinik Psikolog Aysun Şeremet'in blog yazıları." canonical="https://aysunseremet.com/blog" /><Blog /></>} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/iletisim" element={<Iletisim />} />
          <Route path="/sss" element={<><SEO title="Sıkça Sorulan Sorular | Antalya Psikolog Aysun Şeremet" description="Seans süreci, ücretler, online/yüz yüze görüşme, gizlilik ve randevu hakkında sık sorulan sorular. Antalya Psikolog Aysun Şeremet." canonical="https://aysunseremet.com/sss" /><SSS /></>} />
          <Route path="/hizmetlerimiz" element={<><SEO title="Seans Süreci & Hizmetler | Antalya Psikolog Aysun Şeremet" description="Yetişkin, çocuk-ergen ve aile danışmanlığı seans süreci; online ve yüz yüze görüşme seçenekleri. Antalya Uzman Klinik Psikolog Aysun Şeremet." canonical="https://aysunseremet.com/hizmetlerimiz" /><Hizmetlerimiz /></>} />
          <Route path="/login" element={<><SEO title="Giriş Yap | Aysun Şeremet" noIndex /><Login /></>} />
          <Route path="/gizlilik-politikasi" element={<><SEO title="Gizlilik Politikası | Antalya Psikolog Aysun Şeremet" canonical="https://aysunseremet.com/gizlilik-politikasi" /><Gizlilik /></>} />
          <Route path="/kullanim-sartlari" element={<><SEO title="Kullanım Şartları | Antalya Psikolog Aysun Şeremet" canonical="https://aysunseremet.com/kullanim-sartlari" /><Kullanim /></>} />
          <Route path="/aydinlatma-metni" element={<><SEO title="Aydınlatma Metni (KVKK) | Antalya Psikolog Aysun Şeremet" canonical="https://aysunseremet.com/aydinlatma-metni" /><Aydinlatma /></>} />
          <Route path="/randevu-al" element={<RandevuAl />} />
          <Route path="/kvkk" element={<><SEO title="KVKK Politikası | Antalya Psikolog Aysun Şeremet" canonical="https://aysunseremet.com/kvkk" /><KVKK /></>} />
          <Route path="/admin" element={<><SEO title="Yönetim Paneli | Aysun Şeremet" noIndex /><Admin /></>} />
          <Route path="/calisma-alanlari" element={<><SEO title="Çalışma Alanları — EMDR, Şema, BDT | Antalya Psikolog Aysun Şeremet" description="EMDR, Şema Terapi, BDT, Somatik Terapi ve Theraplay yaklaşımlarıyla kaygı, depresyon, travma, sınav kaygısı ve ilişki süreçlerinde destek. Antalya & online." canonical="https://aysunseremet.com/calisma-alanlari" /><CalismaAlanlari /></>} />
          <Route path="/egitimler" element={<Egitimler />} />
          <Route path="/egitimler/:id" element={<EgitimDetail />} />
          <Route path="/videolar" element={<><SEO title="Videolar | Antalya Psikolog Aysun Şeremet" description="Psikoloji, EMDR ve ruh sağlığı üzerine kısa videolar. Uzman Klinik Psikolog Aysun Şeremet." canonical="https://aysunseremet.com/videolar" /><Videolar /></>} />
          <Route path="/hakkimda" element={<><SEO title="Hakkımda | Uzm. Klinik Psikolog Aysun Şeremet - Antalya" description="Uzman Klinik Psikolog Aysun Şeremet — EMDR Avrupa Akredite Uygulayıcı. Eğitimleri, terapi yaklaşımı ve çalışma alanları. Antalya'da online & yüz yüze." canonical="https://aysunseremet.com/hakkimda" /><Hakkimda /></>} />

          {/* Antalya ilçe landing page'leri (yerel SEO) */}
          <Route path="/antalya-psikolog" element={<IlcePsikolog />} />
          <Route path="/muratpasa-psikolog" element={<IlcePsikolog />} />
          <Route path="/konyaalti-psikolog" element={<IlcePsikolog />} />
          <Route path="/kepez-psikolog" element={<IlcePsikolog />} />
          <Route path="/aksu-psikolog" element={<IlcePsikolog />} />
          <Route path="/dosemealti-psikolog" element={<IlcePsikolog />} />
          <Route path="/online-psikolog-antalya" element={<IlcePsikolog />} />

          {/* Niş / Hizmet Landing Page'leri (Google Ads için) */}
          <Route path="/antalya-emdr-terapi" element={<IlcePsikolog />} />
          <Route path="/antalya-sinav-kaygisi" element={<IlcePsikolog />} />
          <Route path="/antalya-cocuk-psikologu" element={<IlcePsikolog />} />

          {/* 404 - Sayfa bulunamadı */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />

        {/* Sağ alt floating butonlar */}
        <FloatingButtons />
      </GlobalBackground>
    </BrowserRouter>
  );
}

export default App;
